import { LoginService } from 'src/app/core/services/login.service';
import { omit } from 'lodash';
import { Injectable } from '@angular/core';
import { gql, Apollo } from 'apollo-angular';
import { combineLatest, Observable } from 'rxjs';
import { pluck } from 'rxjs/operators';
import { Filter } from '../models/filter';
const deleteSupplyByPkMutation = gql`mutation delete_supplies_by_pk($id: uuid!){
  delete_supplies_by_pk(id: $id){
    id
  }
}`;

const deleteSupplyMultipleMutation = gql`mutation delete_supplies_by_pk($idArray: [uuid!]){
  delete_supplies(where:{id:{_in : $idArray}}){
    affected_rows
  }
}`;

const updateSuppliesMutation = gql`mutation update_supplies_by_pk($id: uuid! ,$supply: supplies_set_input!){
  update_supplies_by_pk(pk_columns:{id: $id}, _set: $supply){
    id
  }
}`;

const getSupplyByPkQuery = gql`query get_supply_by_pk($id: uuid!) {
  supplies_by_pk(id: $id) {
    id
    created_at
    updated_at
    name
    alt_text_of_image
    details
    image
    is_featured
    more_images
    page_title
    seo_metadata
    short_id
    short_info
    sku
    specifications
    status
    product_status
    supply_brand_id
    other_brand_name
    deal
    supply_brand {
      id
      name
    }
    supply_category_id
    other_category_name
    supply_category {
      id
      name
    }
    supply_sub_category_id
    other_sub_category_name
    supply_sub_category {
      id
      name
    }
    video
    supply_variants {
      id
      created_at
      updated_at
      actual_price
      attributes
      available_stock
      color
      details
      image
      make_default
      more_images
      price_unit
      selling_price
      specifications
      status
      stock_unit
      supply_id
      title
      video
      sku_code
    }
    tags: j_supplies_supply_tags{
      id
      supply_tag {
        id
        name
      }
    }

    supply_reviews {
      id
      created_at
      updated_at
      supply_id
      supply_variant_id
      rating
      message
      attachments
      status
      type
      dental_supplier_id
      dental_supplier{
        id
        name
        phone
        email
        profile_image
      }
      dental_professional_id
      dental_professional{
        id
        name
        phone
        email
        profile_image
      }
      dental_practice_id
      dental_practice{
        id
        name
        phone
        email
        profile_image
      }
    }
  }
}`;

const insertSuppliesOneMutation = gql`mutation insert_supplies_one($supply: supplies_insert_input!){
  insert_supplies_one(object: $supply){
    id
  }
}`;


const suppliesSubscription = gql`subscription supplies($andList: [supplies_bool_exp!], $sortList:[supplies_order_by!], $limit: Int, $offset: Int) {
  supplies(where: {_and: $andList}, order_by: $sortList, limit: $limit, offset: $offset) {
    id
    created_at
    updated_at
    name
    details
    image
    is_featured
    more_images
    page_title
    seo_metadata
    short_id
    short_info
    sku
    specifications
    status
    product_status
    supply_brand_id
    supply_brand{
      id
      name
    }
    supply_category_id
    supply_category{
      id
      name
    }
    supply_sub_category_id
    supply_sub_category{
      id
      name
    }
    video
    rejection_reason
    deal
    dental_suppliers_id
    dental_supplier{
      id
      name
      business_name
    }
  }
}`;

const suppliesAggregateSubscription = gql`subscription supplies_aggregate($andList: [supplies_bool_exp!]){
  supplies_aggregate(where:{_and: $andList}) {
    aggregate {
      count
    }
  }
}`;


const draftStatusCountSubscription = gql`subscription get_supply_aggregate_status_wise{
  draft: supplies_aggregate(where:{status:{_eq: "DRAFT"}}){
    aggregate{
      count
    }
  }
}`;


const approvalPendingStatusCountSubscription = gql`subscription get_supply_aggregate_status_wise{
  approval_pending: supplies_aggregate(where:{status:{_eq: "PENDING_APPROVAL"}}){
    aggregate{
      count
    }
  }
}`;

const approvedStatusCountSubscription = gql`subscription get_supply_aggregate_status_wise{
  approved: supplies_aggregate(where:{status:{_eq: "APPROVED"}}){
    aggregate{
      count
    }
  }
}`;

const rejectedStatusCountSubscription = gql`subscription get_supply_aggregate_status_wise{
  rejected: supplies_aggregate(where:{status:{_eq: "REJECTED"}}){
    aggregate{
      count
    }
  }
}`;



const draftStatusCountSupplierSubscription = gql`subscription get_supply_aggregate_status_wise($dental_suppliers_id:uuid){
  draft: supplies_aggregate(where:{status:{_eq: "DRAFT"},dental_suppliers_id: {_eq: $dental_suppliers_id } }){
    aggregate{
      count
    }
  }
}`;

const approvalPendingStatusCountSupplierSubscription = gql`subscription get_supply_aggregate_status_wise($dental_suppliers_id:uuid){
  approval_pending: supplies_aggregate(where:{status:{_eq: "PENDING_APPROVAL"},dental_suppliers_id: {_eq: $dental_suppliers_id } }){
    aggregate{
      count
    }
  }
}`;

const approvedStatusCountSupplierSubscription = gql`subscription get_supply_aggregate_status_wise($dental_suppliers_id:uuid){
  approved: supplies_aggregate(where:{status:{_eq: "APPROVED"},dental_suppliers_id: {_eq: $dental_suppliers_id } }){
    aggregate{
      count
    }
  }
}`;


const rejectedStatusCountSupplierSubscription = gql`subscription get_supply_aggregate_status_wise($dental_suppliers_id:uuid){
  rejected: supplies_aggregate(where:{status:{_eq: "REJECTED"},dental_suppliers_id: {_eq: $dental_suppliers_id } }){
    aggregate{
      count
    }
  }
}`;






@Injectable({
  providedIn: 'root'
})
export class SupplyService {

  constructor(private apollo: Apollo, private loginService: LoginService) { }

  insertSuppliesOne(supply: any){
    return this.apollo.use("external").mutate({
      mutation: insertSuppliesOneMutation,
      variables: {supply: omit(supply, ["id"])}
    });
  }

  getProducts(filter: Filter){
    console.log(this.loginService.getLoginData());
    const andList: any =  [{
      status: {"_eq": filter.status}
     },{
      name: {"_ilike" : `%${filter.search}%`},
     }];
     const sortList:any = filter.sort;
     console.log(sortList);

     if(this.loginService.getLoginData().type === 'SUPPLIER'){
      andList.push({
        dental_suppliers_id: {"_eq": this.loginService.getLoginData().id}
      })
     }
     const filters: any = filter.filters.filter(single=>{
       return single.value && single.operator && single.value
     }).map(single=>{
      const columnParts = single.column.column.split(".");
      if(columnParts.length === 1){
        return {
          [single.column.column] :  {
           [single.operator] : (single.operator ==="_ilike") ? `%${single.value}%` : single.value
         }
        }
      } else {
        return { [columnParts[0]] : {
          [columnParts[1]] :  {
           [single.operator] : (single.operator ==="_ilike") ? `%${single.value}%` : single.value
         }
        }}
      }
     });
     const finalArray = andList.concat(filters);
     console.log(finalArray);
    return combineLatest([
      this.apollo.use('external').subscribe({
       query: suppliesSubscription,
       fetchPolicy: "network-only",
       variables: {
         andList: finalArray,
         sortList,
         limit: filter.limit,
         offset: filter.offset
       }
      }).pipe(pluck('data', 'supplies')),
      this.apollo.use('external').subscribe({
        query: suppliesAggregateSubscription,
        fetchPolicy: "network-only",
        variables: {
          andList: finalArray
        }
      }).pipe(pluck('data', 'supplies_aggregate', 'aggregate', 'count')),
      this.loginService.getLoginData().type ==='SUPPLIER' ?

      combineLatest([
        this.apollo.use('external').subscribe({
          query: draftStatusCountSupplierSubscription,
          variables: {
            dental_suppliers_id: this.loginService.getLoginData().id
          },
          fetchPolicy: "network-only"
        }).pipe(pluck("data", "draft", 'aggregate', 'count')),
        this.apollo.use('external').subscribe({
          query: approvalPendingStatusCountSupplierSubscription,
          variables: {
            dental_suppliers_id: this.loginService.getLoginData().id
          },
          fetchPolicy: "network-only"
        }).pipe(pluck("data", "approval_pending", 'aggregate', 'count')),
        this.apollo.use('external').subscribe({
          query: approvedStatusCountSupplierSubscription,
          variables: {
            dental_suppliers_id: this.loginService.getLoginData().id
          },
          fetchPolicy: "network-only"
        }).pipe(pluck("data", "approved", 'aggregate', 'count')),
        this.apollo.use('external').subscribe({
          query: rejectedStatusCountSupplierSubscription,
          variables: {
            dental_suppliers_id: this.loginService.getLoginData().id
          },
          fetchPolicy: "network-only"
        }).pipe(pluck("data", "rejected", 'aggregate', 'count'))
      ])
      :
      combineLatest([
        this.apollo.use('external').subscribe({
          query: draftStatusCountSubscription,
          fetchPolicy: "network-only"
        }).pipe(pluck("data", "draft", 'aggregate', 'count')),
        this.apollo.use('external').subscribe({
          query: approvalPendingStatusCountSubscription,
          fetchPolicy: "network-only"
        }).pipe(pluck("data", "approval_pending", 'aggregate', 'count')),
        this.apollo.use('external').subscribe({
          query: approvedStatusCountSubscription,
          fetchPolicy: "network-only"
        }).pipe(pluck("data", "approved", 'aggregate', 'count')),
        this.apollo.use('external').subscribe({
          query: rejectedStatusCountSubscription,
          fetchPolicy: "network-only"
        }).pipe(pluck("data", "rejected", 'aggregate', 'count'))
      ])
    ]);
  }

  getProductByPk(id : string): Observable<any>{
    return this.apollo.use('external').query({
      query: getSupplyByPkQuery,
      fetchPolicy: "network-only",
      variables: {
        id
      }
    }).pipe(pluck('data', 'supplies_by_pk'))
  }

  updateSuppliesByPk(id: string, supply: any): Observable<any>{
    return this.apollo.use('external').mutate({
      mutation: updateSuppliesMutation,
      variables: {
        id,
        supply
      }
    })
  }

  deleteSupplyByPk(id: string){
    return this.apollo.use('external').mutate({
      mutation: deleteSupplyByPkMutation,
      variables:{
        id
      }
    });
  }

  deleteSupplyMultiple(idArray: string[]){
    return this.apollo.use('external').mutate({
      mutation: deleteSupplyMultipleMutation,
      variables: {
        idArray
      }
    })
  }
}
